<template>
  <div class="mb-4 bg-surface-1 text-text-primary border rounded-lg shadow border-border-subtle">
    <div
      v-if="hasHeader"
      class="p-4 text-lg font-semibold bg-surface-2 border-b rounded-t-lg border-border-subtle"
    >
      <slot name="header">{{ title }}</slot>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});

const slots = useSlots();
const hasHeader = computed(() => Boolean(props.title || slots.header));
</script>
